import {ModalWithNewForm, Message} from '~/components'
import {Input, ArrayField} from '@eitje/web_components'
import {useParams} from 'react-router'
import {BillingInfo} from '@eitje/api'
import {goBack} from '~/routing/actions'
import {validateEmail} from '~/helpers'

const emailArrayFieldFields = [{Component: Input, field: 'email', required: true, validate: validateEmail}]

export const EditBillingInfo = () => {
	const {id} = useParams()
	const billingInfo = BillingInfo.useFind(id)

	const initialValues = {
		...billingInfo,
		emails: billingInfo.emails.map(email => ({email})),
	}

	const handleSubmit = ({emails, ...data}) => {
		return billingInfo.update({
			...data,
			emails: emails._map('email'),
		})
	}

	return (
		<ModalWithNewForm
			name="edit_billing_info"
			initialValues={initialValues}
			onSubmit={handleSubmit}
			afterSubmit={goBack}
			width={400}
			modalProps={{okButtonProps: {t: 'common.save'}}}
		>
			<Message t="billing.edit_billing_info.message" />
			<Input field="company_name" />
			<Input field="signer_name" />
			<ArrayField addItemLabel="email" minItems={1} field="emails" fields={emailArrayFieldFields} />
		</ModalWithNewForm>
	)
}
